import { Phone, MessageCircle } from "lucide-react";
import { fbq } from "@/lib/tracking";
import { iclosedUrl } from "@/lib/booking";

const WHATSAPP_URL = "https://wa.me/33678229256?text=" + encodeURIComponent("Bonjour Horsepower, je souhaite des informations sur la formation reprogrammation moteur.");

export default function StickyCTA() {
  return (
    <>
      {/* Mobile sticky bottom bar - hidden on lg+ */}
      <div
        className="fixed inset-x-0 bottom-0 z-40 lg:hidden bg-black/95 backdrop-blur-md border-t border-[#FFD60A]/40 shadow-[0_-8px_30px_rgba(0,0,0,0.6)]"
        data-testid="sticky-mobile-cta"
      >
        <div className="flex items-stretch">
          <a
            href={iclosedUrl("cta-sticky-mobile")}
            target="_blank"
            rel="noreferrer"
            onClick={() => fbq.schedule({ content_name: "Sticky Bar - Réserver iClosed" })}
            className="flex-1 flex items-center justify-center gap-2 px-3 py-4 bg-[#FFD60A] text-black font-bold uppercase text-xs tracking-wider hover:bg-yellow-300 active:bg-yellow-300 transition-colors"
            data-testid="sticky-cta-call"
          >
            <Phone size={14} strokeWidth={2.5} />
            <span>Réserver un appel</span>
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => fbq.contact({ content_name: "Sticky Bar - WhatsApp icon" })}
            aria-label="WhatsApp Horsepower"
            className="flex items-center justify-center px-5 py-4 bg-[#25D366] text-white hover:bg-[#1ebe5d] active:bg-[#1ebe5d] transition-colors"
            data-testid="sticky-cta-whatsapp"
          >
            <MessageCircle size={20} strokeWidth={2} />
          </a>
        </div>
      </div>

      {/* Desktop floating WhatsApp - bottom-right, above Emergent badge */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        onClick={() => fbq.contact({ content_name: "Floating WhatsApp" })}
        aria-label="Discuter sur WhatsApp"
        className="hidden lg:flex fixed bottom-[70px] right-6 z-40 items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] text-white font-semibold text-sm rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.5)] hover:shadow-[0_8px_40px_rgba(37,211,102,0.7)] hover:scale-105 transition-all group"
        data-testid="floating-whatsapp"
      >
        <div className="relative">
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-[#FFD60A] rounded-full animate-pulse" />
          <MessageCircle size={20} strokeWidth={2.2} />
        </div>
        <span>WhatsApp</span>
        <span className="font-mono text-[10px] uppercase tracking-widest text-white/80 border-l border-white/30 pl-3">
          Réponse rapide
        </span>
      </a>
    </>
  );
}
